var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 9.625,
    viewBox: "0 0 16.5 9.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5 -10.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.313,11.419H5.188a.67.67,0,0,1-.688-.647h0a.67.67,0,0,1,.688-.647H20.313a.67.67,0,0,1,.687.647h0A.67.67,0,0,1,20.313,11.419Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.313,18.169H5.188a.67.67,0,0,1-.688-.647h0a.67.67,0,0,1,.688-.647H20.313a.67.67,0,0,1,.687.647h0A.67.67,0,0,1,20.313,18.169Z",
    transform: "translate(0 -2.584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.313,24.919H5.188a.67.67,0,0,1-.688-.647h0a.67.67,0,0,1,.688-.647H20.313a.67.67,0,0,1,.687.647h0A.67.67,0,0,1,20.313,24.919Z",
    transform: "translate(0 -5.169)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.2004dc04.svg";
export { ForwardRef as ReactComponent };